import { call, put, take } from 'redux-saga/effects';
import * as storage from 'utils/storage';
import { fetchGroups } from 'store/actions/groupActions';
import Api from 'api/groups';

export function* fetchGroupsSaga() {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    const response = yield call(Api.fetchGroups, {
      headers: { 'x-blu-jwt': `${accessToken}` },
    });
    yield put({ type: fetchGroups.success, payload: response.data });
  } catch (error) {
    const err = error as Error;
    yield put({ type: fetchGroups.failure, payload: err.message });
  }
}

export function* watchFetchGroups() {
  yield take(fetchGroups.request);
  yield call(fetchGroupsSaga);
}
